import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { GridComponent } from './grid.component';

@NgModule({
	imports: [
		RouterModule.forChild([
			{
				path:'',
				component: GridComponent
			}
		])
	],
	exports: [
		RouterModule
	]
})
export class GridRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/view/grid/grid-routing.module.ts